import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import agent from '../agent';

/**
 * Async thunk
 */
export const getNotificationLinkLoss = createAsyncThunk(
  'notificationlinkloss/get',
  async (data, thunkApi) => {
    try {
      const response = await agent.notificationLinkLoss.get(data);
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

const initialState = {
  status: 'idle',
  loading: false,
  error: null,
  getNotificationLinkLossResponse: []
};

const notificationLinkLossSlice = createSlice({
  name: 'notificationlinkloss',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNotificationLinkLoss.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getNotificationLinkLoss.fulfilled, (state, action) => {
        state.status = 'success';
        state.getNotificationLinkLossResponse = action.payload;
      })
      .addCase(getNotificationLinkLoss.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  }
});

export const {
  notificationLinkLossPageUnloaded,
  clearnotificationLinkLoss,
} = notificationLinkLossSlice.actions;

export default notificationLinkLossSlice.reducer;
